/* eslint-disable camelcase */
import { Component } from "react";
import { connect } from "react-redux";
import { Segment, Header, Button, Image } from "semantic-ui-react";
import styled from "styled-components";

import {
  getMetaContent,
  indiscriminatelyCombineFlashMessages,
} from "../../Common/helpers/meta";
import FormError from "./FormError";

export const HeaderText = styled(Header)`
  &&& {
    margin-bottom: 1.75em;
    font-size: 20px;
    font-weight: 600;
    white-space: nowrap;
  }
`;

const SSOButtonContent = styled(Button.Content)`
  display: inline;
  vertical-align: sub;
  margin-left: 1em;
`;

class Login extends Component {
  state = {
    error: "",
    showError: false,
    loading: false,
  };

  beginAuthentication = (loadingKey) =>
    this.setState({
      [loadingKey]: true,
      error: "",
      oauthError: "",
    });

  displayError = () => {
    const { error, showError } = this.state;
    return error.length > 0 && showError;
  };

  render() {
    let flash;
    const { session } = this.props;
    const { error, loading } = this.state;

    if (session) {
      flash = session.flash;
    }

    let oauthError = "";

    if (flash && flash.flashes && Object.keys(flash.flashes).length > 0) {
      oauthError = indiscriminatelyCombineFlashMessages(flash.flashes);
    }

    const makingRequest = loading;

    const googleAuthUrlFragment = `/saml_providers/tripadvisor-entra`;

    return (
      <Segment className="login">
        <HeaderText textAlign="center" as="h2">
          Welcome to HireArt.
        </HeaderText>

        <FormError error={error || oauthError} />

        <form action={googleAuthUrlFragment} method="post">
          <input
            type="hidden"
            name="authenticity_token"
            value={getMetaContent("csrf-token")}
          />
          <Button
            className="google-login-button"
            fluid
            basic
            disabled={makingRequest}
            type="submit"
          >
            <Image className="linkedin" inline src="/assets/entra-icon.svg" />
            <SSOButtonContent>Sign in with Entra</SSOButtonContent>
          </Button>
        </form>
      </Segment>
    );
  }
}

const mapDispatchToProps = ({ session }) => ({ session });

export default connect(mapDispatchToProps)(Login);
